module.exports = __webpack_public_path__ + "img/8.c7b6595.png";